// Rango Unicode de marcas diacríticas combinantes (0x0300-0x036F), construido
// a partir de códigos numéricos para evitar caracteres de acento sueltos en
// el propio código fuente.
const MARCAS_DIACRITICAS = new RegExp(`[${String.fromCharCode(768)}-${String.fromCharCode(879)}]`, "g");

// Búsqueda simple e insensible a mayúsculas/acentos por cliente, dirección
// de entrega o chofer. Corre sobre los pedidos ya cargados de la pestaña
// activa (sin ir de nuevo al backend).
const normalizar = (texto) =>
  (texto ?? "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(MARCAS_DIACRITICAS, "");

export const pedidoCoincideConBusqueda = (pedido, termino) => {
  const t = normalizar(termino).trim();
  if (!t) return true;
  return [pedido.cliente, pedido.direccion_entrega, pedido.nombre_apellido].some((campo) =>
    normalizar(campo).includes(t)
  );
};
